import { DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useAgencyProviders from '@hooks/useAgencyProviders'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import AgencyListItem from './AgencyListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'agency_string',
      label: 'Agency Title or ID',
    },
  ]
}

interface AgenciesProps {
  providerPriceListId: number,
}

const Agencies = (props: AgenciesProps) => {
  const { providerPriceListId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const agencyProviderPayload = useAgencyProviders({
    filters: {
      ...pageFilters,
      provider_price_list_id: providerPriceListId,
    },
    performHttpRequests: !!providerPriceListId,
    requestOptions: {
      include_agency_provider_agency: true,
    },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAgencyProviders,
    // @ts-expect-error TS2339
    filteredAgencyProviderCount,
    hasFilteredAgencyProviders,
    loading,
  } = agencyProviderPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Agencies"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      {!loading && hasFilteredAgencyProviders && (
        <DashboardModule.ScrollableSection>
          {filteredAgencyProviders.map(agencyProvider => (
            <AgencyListItem
              key={agencyProvider.id}
              agencyProvider={agencyProvider}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      {!loading && !hasFilteredAgencyProviders && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Agencies Present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Agencies will appear here when this Price List is assigned to them
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredAgencyProviderCount}
        loading={loading}
      />
    </DashboardModule>
  )
}

export default Agencies
